<template>
  <div id="app">
    <RouterView />
  </div>
</template>

<script setup>
import { RouterView } from 'vue-router';
</script>

<style>
/* Global styles are imported in main.js */
#app {
  min-height: 100vh;
}
</style>
